import axios from 'axios';
import { openErrorNotification } from 'hyarchis-global';
import StoreContainer from 'store/container';
import SettingsDirectAccess from 'store/settings/directAccess';
import AuthDirectAccess from 'store/auth/directAccess';
import AuthorizationRepository from 'services/api-repositories/authorization/AuthorizationRepository';
import { setAuth, removeAuth } from 'store/auth/actions';
import { formatEndpoint, HcsAPI } from 'services/api-repositories';

export default () => {
  HcsAPI.defaults.baseURL = formatEndpoint(SettingsDirectAccess.getSettings().endpoint);
  HcsAPI.interceptors.request.use(
    async (config) => {
      let auth = AuthDirectAccess.getAuth();
      if (!auth.accessToken) {
        auth = await AuthorizationRepository.createAuth();
        StoreContainer.store.dispatch(setAuth(auth));
      }

      if (auth) {
        config.headers!.Authorization = // eslint-disable-line no-param-reassign
          config.headers!.Authorization || `${auth.tokenType} ${auth.accessToken}`;
        config.headers!['Cache-Control'] = 'no-cache, no-store'; // eslint-disable-line no-param-reassign
      }

      return config;
    },
    (error) => Promise.reject(error),
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        openErrorNotification('You are unauthorized.');
        StoreContainer.store.dispatch(removeAuth());
      }

      return Promise.reject(error);
    },
  );
};
